import { z } from 'zod'

export const configSchema = z.strictObject({
  zendesk: z.object({
    inAppChatKey: z.string(),
  }),
})

export type Config = z.infer<typeof configSchema>
